import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Grid,
  Text,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  Divider,
  Center,
  Image,
  ModalFooter,
  Button,
  useBreakpointValue,
} from "@chakra-ui/react";
import ShadowBox from "components/common/ShadowBox/ShadowBox";
import React from "react";
import StepsHeader from "./StepsHeader";
import { capitalizeArray, getValueOrDefault } from "./utils/function";
import TableLoader from "components/common/TableLoader/TableLoader";
import { PreviewModalI } from "./utils/interface";

export default function PreviewModal({
  type,
  isOpen,
  onClose,
  values,
  isSubmit,
  setIsSubmit,
}: PreviewModalI): JSX.Element {
  let valuess: any = undefined;
  if (type === "create") {
    valuess = values?.value;
  } else {
    valuess = values?.value?.values;
  }

  const viewerWidth = useBreakpointValue({ lg: true });
  let width = "90vw";

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay />
      <ModalContent
        position="fixed"
        right={isOpen ? "0" : `-${width}`}
        top="0"
        height="100vh"
        width={viewerWidth ? width : "100vw"}
        animation={`${
          isOpen ? "slideIn" : "slideOut"
        } 0.8s ease-in-out forwards`}
      >
        <ModalHeader
          fontSize={{ base: "1rem", md: "1.6rem" }}
          color="teal.300"
          fontWeight="700"
          p=".6rem .6rem"
          ml="1rem"
          textTransform="capitalize"
        >
          Preview
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ShadowBox>
            <Box
              maxH="555px"
              p={1}
              overflow="hidden auto"
              className="customScrollBar"
            >
              <StepsHeader heading="WorkFlow Features" mt={0} />
              <Box>
                <Text fontWeight="500">Logo: </Text>
                <Center>
                  <Image src={valuess?.logo?.file} boxSize={125} />
                </Center>
                <Grid templateColumns={{ lg: "1fr 1fr" }} gap={2} mt={2}>
                  <Flex alignItems="center" gap={4}>
                    <Text fontWeight="500">Workflow Name: </Text>
                    <Text>{getValueOrDefault(valuess?.workFlowName)}</Text>
                  </Flex>
                  <Flex alignItems="center" gap={4}>
                    <Text fontWeight="500">Identifier: </Text>
                    <Text>{getValueOrDefault(valuess?.identifier)}</Text>
                  </Flex>
                  <Flex alignItems="center" gap={4}>
                    <Text fontWeight="500">Number of levels: </Text>
                    <Text>{getValueOrDefault(valuess?.levels)}</Text>
                  </Flex>
                  <Flex alignItems="center" gap={4}>
                    <Text fontWeight="500">Document Type: </Text>
                    <Text>{getValueOrDefault(valuess?.documentType)}</Text>
                  </Flex>
                </Grid>
              </Box>

              <StepsHeader heading="Users" mt={3} />
              <Box overflowY="auto" className="customScrollBar">
                <Table size="sm">
                  <Thead>
                    <Tr>
                      <Th>User Name</Th>
                      <Th>Role</Th>
                      <Th>Level</Th>
                      <Th>Keep Active</Th>
                      <Th>Designation</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {valuess?.approvals.length === 0 ? (
                      <Tr>
                        <Td colSpan={5}>
                          <Flex justify="center">
                            <Text fontSize="sm">No Data Available to Show</Text>
                          </Flex>
                        </Td>
                      </Tr>
                    ) : (
                      valuess?.approvals.map((approval: any, index: any) => (
                        <Tr key={index}>
                          <Td>
                            {type === "create"
                              ? getValueOrDefault(approval?.username?.email)
                              : getValueOrDefault(approval?.username)}
                          </Td>
                          <Td>
                            {type === "create"
                              ? getValueOrDefault(approval?.role.label)
                              : getValueOrDefault(approval?.role)}
                          </Td>
                          <Td>
                            {type === "create"
                              ? getValueOrDefault(approval?.level.label)
                              : getValueOrDefault(approval?.level)}
                          </Td>
                          <Td>
                            {type === "create"
                              ? getValueOrDefault(approval?.isActive.label)
                              : approval?.isActive === true
                              ? "Yes"
                              : "No"}
                          </Td>
                          <Td>{getValueOrDefault(approval?.designation)}</Td>
                        </Tr>
                      ))
                    )}
                  </Tbody>
                </Table>
              </Box>
              <StepsHeader heading="Filters" mt={3} />
              <Text fontWeight="500" fontSize="lg">
                Search Filters
              </Text>
              <Box overflowY="auto" className="customScrollBar">
                <Table mt={3}>
                  <Thead>
                    <Tr>
                      <Th>Keys</Th>
                      <Th>Is Active</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>
                        {type === "create"
                          ? getValueOrDefault(valuess?.searchFilter?.key?.label)
                          : getValueOrDefault(valuess?.searchFilter?.key)}
                      </Td>
                      <Td>
                        {valuess?.searchFilter?.isActive === true
                          ? "Yes"
                          : "No"}
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </Box>
              <Text mt={3} fontWeight="500" fontSize="lg">
                Filters
              </Text>
              {values?.filters && valuess?.filters?.map((filter: any, index: any) => (
                <React.Fragment key={index}>
                  <Box bg="teal.50" p={2} mt={3}>
                    <Grid templateColumns={{ lg: "1fr 1fr" }} gap={2}>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Filter Label: </Text>
                        <Text>{getValueOrDefault(filter?.label)}</Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Placeholder: </Text>
                        <Text>{getValueOrDefault(filter?.placeholder)}</Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Key: </Text>
                        <Text>
                          {type === "create"
                            ? getValueOrDefault(filter?.key?.label)
                            : getValueOrDefault(filter?.key)}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Is Active: </Text>
                        <Text>
                          {type === "create"
                            ? getValueOrDefault(filter?.isActive?.label)
                            : getValueOrDefault(
                                filter?.isActive === true ? "Yes" : "No"
                              )}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Is Multi Select: </Text>
                        <Text>
                          {type === "create"
                            ? getValueOrDefault(filter?.isMultiSelect?.label)
                            : getValueOrDefault(
                                filter?.isMultiSelect === true ? "Yes" : "No"
                              )}
                        </Text>
                      </Flex>
                    </Grid>
                    <Text mt={3} fontWeight="500">
                      Filter Options:{" "}
                    </Text>
                    <Box overflowY="auto" className="customScrollBar">
                      <Table mt={3}>
                        <Thead>
                          <Tr>
                            <Th>Label</Th>
                            <Th>Key</Th>
                            <Th>Active Mode</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {filter.filters.map((option: any, indexKey: any) => (
                            <Tr>
                              <Td>{getValueOrDefault(option.label)}</Td>
                              <Td>{getValueOrDefault(option.key)}</Td>
                              <Td>{option.isActive === true ? "Yes" : "No"}</Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </Box>
                  </Box>
                  {index < valuess.filters.length - 1 && (
                    <Divider p={2} mb={4} />
                  )}
                </React.Fragment>
              ))}
              <Text fontWeight="500" mt={3} fontSize="lg">
                Date Filter
              </Text>
              <Grid templateColumns={{ lg: "1fr 1fr" }} gap={2} mt={3}>
                <Flex alignItems="center" gap={4}>
                  <Text fontWeight="500">Filter Key: </Text>
                  <Text>
                    {type === "create"
                      ? getValueOrDefault(valuess?.dateFilter?.filterKey?.label)
                      : getValueOrDefault(valuess?.dateFilter?.filterKey)}
                  </Text>
                </Flex>
                <Flex alignItems="center" gap={4}>
                  <Text fontWeight="500">Date Range: </Text>
                  <Text>
                    {type === "create"
                      ? getValueOrDefault(valuess?.dateFilter?.range?.label)
                      : getValueOrDefault(valuess?.dateFilter?.range)}
                  </Text>
                </Flex>
                <Flex alignItems="center" gap={4}>
                  <Text fontWeight="500">Show Date Filter: </Text>
                  <Text>
                    {valuess?.dateFilter?.showFilter === true ? "Yes" : "No"}
                  </Text>
                </Flex>
                <Flex alignItems="center" gap={4}>
                  <Text fontWeight="500">Apply Date Range: </Text>
                  <Text>
                    {valuess?.dateFilter?.rangeActive === true ? "Yes" : "No"}
                  </Text>
                </Flex>
                <Flex alignItems="center" gap={4}>
                  <Text fontWeight="500">Use Date Range Picker: </Text>
                  <Text>
                    {valuess?.dateFilter?.rangePicker === true ? "Yes" : "No"}
                  </Text>
                </Flex>
              </Grid>
              <Text fontWeight="500" mt={3} fontSize="lg">
                Sort By
              </Text>
              <Box overflowY="auto" className="customScrollBar">
                <Table mt={3}>
                  <Thead>
                    <Tr>
                      <Th>Sort Mode</Th>
                      <Th>Keys</Th>
                      <Th>Is Active</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {values?.sortBy && valuess?.sortBy?.map((sort: any, index: any) => (
                      <Tr key={index}>
                        <Td>
                          {type === "create"
                            ? getValueOrDefault(sort?.mode?.label)
                            : getValueOrDefault(
                                sort?.mode === -1 ? "Descending" : "Ascending"
                              )}
                        </Td>
                        <Td>
                          {type === "create"
                            ? getValueOrDefault(sort?.key?.label)
                            : getValueOrDefault(sort?.key)}
                        </Td>
                        <Td>{sort?.isActive === true ? "Yes" : "No"}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </Box>
              <StepsHeader heading="Notification" mt={3} />
              <Box mt={3} overflowY="auto" className="customScrollBar">
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Approvals</Th>
                      <Th>Level</Th>
                      <Th>Is Active</Th>
                      <Th>Type</Th>
                    </Tr>
                  </Thead>
                  <TableLoader
                    show={valuess?.notification?.length}
                    loader={false}
                  >
                    <Tbody>
                      {valuess?.notification?.map(
                        (notification: any, index: number) => (
                          <Tr key={index}>
                            <Td>
                              <Text textTransform="capitalize">
                                {getValueOrDefault(
                                  notification?.approval
                                    ? capitalizeArray(
                                        notification?.approval,
                                        type
                                      ).join(", ")
                                    : undefined
                                )}
                              </Text>
                            </Td>
                            <Td>
                              <Text textTransform="capitalize">
                                {getValueOrDefault(
                                  notification?.level
                                    ? capitalizeArray(
                                        notification?.level,
                                        type
                                      ).join(", ")
                                    : undefined
                                )}
                              </Text>
                            </Td>
                            <Td>
                              {type === "create"
                                ? getValueOrDefault(
                                    notification?.isActive?.label
                                  )
                                : notification?.isActive === true
                                ? "Yes"
                                : "No"}
                            </Td>
                            <Td>
                              <Text textTransform="capitalize">
                                {getValueOrDefault(
                                  notification?.type
                                    ? capitalizeArray(notification?.type).join(
                                        ", "
                                      )
                                    : undefined
                                )}
                              </Text>
                            </Td>
                          </Tr>
                        )
                      )}
                    </Tbody>
                  </TableLoader>
                </Table>
              </Box>
              <StepsHeader heading="Approval Modal" mt={3} />
              <Grid
                templateColumns={{
                  lg:
                    valuess?.fileViewer?.approvalModalOption?.label ===
                      "Labels" ||
                    valuess?.fileViewer?.approvalModalOption?.label === "Table"
                      ? "1fr 1fr 1fr"
                      : "1fr 1fr",
                }}
                gap={4}
              >
                <Flex alignItems="center" gap={4}>
                  <Text fontWeight="500">Show Approval Modal: </Text>
                  <Text>
                    {valuess?.fileViewer?.show === true ? "Yes" : "No"}
                  </Text>
                </Flex>
                <Flex alignItems="center" gap={4}>
                  <Text fontWeight="500">Type: </Text>
                  <Text>
                    {type === "create"
                      ? getValueOrDefault(
                          valuess?.fileViewer?.approvalModalOption?.label
                        )
                      : getValueOrDefault(
                          valuess?.fileViewer?.approvalModalOption
                        )}
                  </Text>
                </Flex>
                {valuess?.fileViewer?.approvalModalOption?.label ===
                  "Labels" && (
                  <Flex alignItems="center" gap={4}>
                    <Text fontWeight="500">Is Editable: </Text>
                    <Text>
                      {valuess?.fileViewer?.editable === true ? "Yes" : "No"}
                    </Text>
                  </Flex>
                )}
                {valuess?.fileViewer?.approvalModalOption?.label ===
                  "Table" && (
                  <Flex alignItems="center" gap={4}>
                    <Text fontWeight="500">Show File: </Text>
                    <Text>
                      {valuess?.fileViewer?.tableFile === true ? "Yes" : "No"}
                    </Text>
                  </Flex>
                )}
              </Grid>
              <Text fontWeight="500" mt={3} fontSize="lg">
                Bulk Filters Approval
              </Text>
              <Grid templateColumns={{ lg: "1fr 1fr" }} gap={4} mt={3}>
                <Flex alignItems="center" gap={4}>
                  <Text fontWeight="500">Allow bulk Approve: </Text>
                  <Text>
                    {valuess?.bulkApproveApproval === true ? "Yes" : "No"}
                  </Text>
                </Flex>
                <Flex alignItems="center" gap={4}>
                  <Text fontWeight="500">Allow bulk Reject: </Text>
                  <Text>
                    {valuess?.bulkRejectApproval === true ? "Yes" : "No"}
                  </Text>
                </Flex>
              </Grid>
              <StepsHeader heading="Table" mt={3} />
              {valuess?.table.map((item: any, index: any) => (
                <React.Fragment key={index}>
                  <Box bg="teal.50" p={2}>
                    <Grid templateColumns={{ lg: "1fr 1fr 1fr" }} gap={2}>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Show Table: </Text>
                        <Text>
                          {type === "create"
                            ? getValueOrDefault(item.isActive?.label)
                            : getValueOrDefault(item?.isActive)}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Show Pagination: </Text>
                        <Text>
                          {type === "create"
                            ? getValueOrDefault(
                                item?.isPaginate?.isActive?.label
                              )
                            : getValueOrDefault(item?.isPaginate?.isActive)}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Pagination Limit: </Text>
                        <Text fontWeight="500">
                          {getValueOrDefault(item?.isPaginate?.paginationLimit)}
                        </Text>
                      </Flex>
                    </Grid>
                    <Grid templateColumns={{ lg: "1fr 1fr" }} gap={2} mt={2}>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Header: </Text>
                        <Text>{getValueOrDefault(item?.header?.label)}</Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Show Header: </Text>
                        <Text>
                          {type === "create"
                            ? getValueOrDefault(item?.header?.isActive?.label)
                            : getValueOrDefault(
                                item?.header?.isActive === true ? "Yes" : "No"
                              )}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Show Filter: </Text>
                        <Text>
                          {item?.header?.filterActive === true ? "Yes" : "No"}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Show Date Filter: </Text>
                        <Text>
                          {item?.header?.dateActive === true ? "Yes" : "No"}
                        </Text>
                      </Flex>
                    </Grid>
                    <Text fontWeight="500" mt={3} fontSize="lg">
                      Actions
                    </Text>
                    <Grid
                      templateColumns={{ lg: "1fr 1fr 1fr" }}
                      gap={2}
                      mt={3}
                    >
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Can View? : </Text>
                        <Text>
                          {item?.action?.view === true ? "Yes" : "No"}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Can Edit? : </Text>
                        <Text>
                          {item?.action?.edit === true ? "Yes" : "No"}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Can Delete? : </Text>
                        <Text>
                          {item?.action?.delete === true ? "Yes" : "No"}
                        </Text>
                      </Flex>
                    </Grid>
                    <Grid templateColumns={{ lg: "1fr 1fr" }} gap={2} mt={2}>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Download PDF: </Text>
                        <Text>
                          {item?.action?.downloadPDF === true ? "Yes" : "No"}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" gap={4}>
                        <Text fontWeight="500">Download Excel: </Text>
                        <Text>
                          {item?.action?.downloadExcel === true ? "Yes" : "No"}
                        </Text>
                      </Flex>
                    </Grid>
                    <Text fontWeight="500" mt={3} fontSize="lg">
                      Column Names
                    </Text>
                    <Flex alignItems="center" gap={4} mt={3}>
                      <Text fontWeight="500">
                        Allow transform to Uppercase:{" "}
                      </Text>
                      <Text>
                        {item?.columnNameUpperCase === true ? "Yes" : "No"}
                      </Text>
                    </Flex>
                    <Box mt={3} overflowY="auto" className="customScrollBar">
                      <Table>
                        <Thead>
                          <Tr>
                            <Th>Label</Th>
                            <Th>Key</Th>
                            <Th whiteSpace="nowrap">Active Mode</Th>
                            <Th whiteSpace="nowrap">Align label Center</Th>
                            <Th whiteSpace="nowrap">Nowrap</Th>
                            <Th whiteSpace="nowrap">Select Type</Th>
                            <Th>File</Th>
                            {item.columnName.some(
                              (column: any) => column.isFile === true
                            ) && (
                              <>
                                <Th whiteSpace="nowrap">View File</Th>
                                <Th whiteSpace="nowrap">Download File</Th>
                              </>
                            )}
                            <Th>Sort</Th>
                            <Th whiteSpace="nowrap">Truncated</Th>
                            {item.columnName.some(
                              (column: any) => column.truncatedActive === true
                            ) && <Th whiteSpace="nowrap">Tooltip Label</Th>}
                          </Tr>
                        </Thead>
                        <Tbody>
                          {item?.columnName.map(
                            (option: any, indexKey: any) => (
                              <Tr>
                                <Td>{getValueOrDefault(option?.label)}</Td>
                                <Td>{getValueOrDefault(option?.key)}</Td>
                                <Td>
                                  {option?.isActive === true ? "Yes" : "No"}
                                </Td>
                                <Td>
                                  {option?.labelCenter === true ? "Yes" : "No"}
                                </Td>
                                <Td>
                                  {option?.labelNoWrap === true ? "Yes" : "No"}
                                </Td>
                                <Td>
                                  {type === "create" ? (
                                    getValueOrDefault(option.rowType?.label)
                                  ) : (
                                    <Text textTransform="capitalize">
                                      {getValueOrDefault(option.rowType)}
                                    </Text>
                                  )}
                                </Td>
                                <Td>
                                  {option?.isFile === true ? "Yes" : "No"}
                                </Td>
                                {item.columnName.some(
                                  (column: any) => column.isFile === true
                                ) &&
                                  item.columnName[index].isFile === true && (
                                    <>
                                      <Td>
                                        {option?.fileView === true
                                          ? "Yes"
                                          : "No"}
                                      </Td>
                                      <Td>
                                        {option?.fileDownload === true
                                          ? "Yes"
                                          : "No"}
                                      </Td>
                                    </>
                                  )}
                                <Td>
                                  {option?.sortActive === true ? "Yes" : "No"}
                                </Td>
                                <Td>
                                  {option?.truncatedActive === true
                                    ? "Yes"
                                    : "No"}
                                </Td>
                                {item.columnName.some(
                                  (column: any) =>
                                    column.truncatedActive === true
                                ) && (
                                  <Td>
                                    {getValueOrDefault(option.tooltipLabel)}
                                  </Td>
                                )}
                              </Tr>
                            )
                          )}
                        </Tbody>
                      </Table>
                    </Box>
                    <Flex alignItems="center" gap={4} mt={3}>
                      <Text fontWeight="500">Add Drawer Table: </Text>
                      <Text>
                        {item?.drawerTableActive === true ? "Yes" : "No"}
                      </Text>
                    </Flex>
                    {item?.drawerTableActive && (
                      <Box overflowY="auto" className="customScrollBar">
                        <Table mt={3}>
                          <Thead>
                            <Tr>
                              <Th>Label</Th>
                              <Th whiteSpace="nowrap">Active Mode</Th>
                              <Th whiteSpace="nowrap">Align label Center</Th>
                              <Th whiteSpace="nowrap">Nowrap</Th>
                              <Th whiteSpace="nowrap">Select Type</Th>

                              <Th></Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {item?.drawerTable.map(
                              (option: any, index: number) => (
                                <Tr key={index}>
                                  <Td>{getValueOrDefault(option?.label)}</Td>
                                  <Td>
                                    {option?.isActive === true ? "Yes" : "No"}
                                  </Td>
                                  <Td>
                                    {option?.labelCenter === true
                                      ? "Yes"
                                      : "No"}
                                  </Td>
                                  <Td>
                                    {option?.labelNoWrap === true
                                      ? "Yes"
                                      : "No"}
                                  </Td>
                                  <Td>
                                    {type === "create"
                                      ? getValueOrDefault(
                                          option?.rowType?.label
                                        )
                                      : getValueOrDefault(option?.rowType)}
                                  </Td>
                                </Tr>
                              )
                            )}
                          </Tbody>
                        </Table>
                      </Box>
                    )}
                  </Box>
                  {index < valuess?.table.length - 1 && (
                    <Divider p={2} mb={4} />
                  )}
                </React.Fragment>
              ))}
              <StepsHeader heading="Triggers" mt={3} />
              <Box mt={3} overflowY="auto" className="customScrollBar">
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Approvals</Th>
                      <Th>Level</Th>
                      <Th>Is Active</Th>
                      <Th>Actions</Th>
                      <Th>Method</Th>
                    </Tr>
                  </Thead>
                  <TableLoader show={valuess?.triggers.length} loader={false}>
                    <Tbody>
                      {valuess?.triggers.map((trigger: any, index: number) => (
                        <Tr key={index}>
                          <Td>
                            {type === "create"
                              ? getValueOrDefault(trigger?.approval?.label)
                              : getValueOrDefault(trigger?.approval)}
                          </Td>
                          <Td>
                            {type === "create"
                              ? getValueOrDefault(trigger?.level?.label)
                              : getValueOrDefault(trigger?.level)}
                          </Td>
                          <Td>
                            {type === "create"
                              ? getValueOrDefault(trigger?.isActive?.label)
                              : getValueOrDefault(trigger?.isActive)}
                          </Td>
                          <Td>
                            {type === "create"
                              ? getValueOrDefault(trigger?.action?.label)
                              : getValueOrDefault(trigger?.action)}
                          </Td>
                          <Td>{getValueOrDefault(trigger?.method)}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </TableLoader>
                </Table>
              </Box>
              <StepsHeader heading="Other" mt={3} />
              <Box mt={3} overflowY="auto" className="customScrollBar">
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Show Tab</Th>
                      <Th>URL</Th>
                      <Th>Label</Th>
                      <Th>Icon</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {values?.tab ? valuess?.tab?.map((tab: any, index: number) => (
                      <Tr key={index}>
                        <Td>{tab?.isActive === true ? "Yes" : "No"}</Td>
                        <Td>
                          <Text whiteSpace="nowrap">
                            {getValueOrDefault(tab?.url)}
                          </Text>
                        </Td>
                        <Td>{getValueOrDefault(tab?.label)}</Td>
                        <Td>{getValueOrDefault(tab?.icon)}</Td>
                      </Tr>
                    )) : <Text textAlign="center">No Tab Exists</Text>}
                  </Tbody>
                </Table>
              </Box>
            </Box>
          </ShadowBox>
        </ModalBody>
        <ModalFooter>
          {type === "create" && (
            <Flex justifyContent="flex-end" alignItems="center" gap={2}>
              <Text fontWeight="500">Are you ready to submit?</Text>
              <Button
                colorScheme="green"
                onClick={() => {
                  setIsSubmit(true);
                  onClose();
                }}
              >
                Yes
              </Button>
              <Button colorScheme="red" onClick={onClose}>
                No
              </Button>
            </Flex>
          )}
        </ModalFooter>
      </ModalContent>
      <style>
        {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
      </style>
    </Modal>
  );
}
